import { render, staticRenderFns } from "./BoardsList.vue?vue&type=template&id=874731e2&"
import script from "./BoardsList.vue?vue&type=script&lang=js&"
export * from "./BoardsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports